module.exports = __webpack_public_path__ + "img/queue_card_medium_disabled.5367e85f.svg";